"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceRgbaColor = exports.applyOpacityToHex = void 0;
function applyOpacityToHex(hex, opacity) {
    const strippedHex = hex.replace('#', '');
    const red = parseInt(strippedHex.substring(0, 2), 16);
    const green = parseInt(strippedHex.substring(2, 4), 16);
    const blue = parseInt(strippedHex.substring(4, 6), 16);
    return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}
exports.applyOpacityToHex = applyOpacityToHex;
// This function was made for the use case of replacing the mui defined shadows rgba values with our own hex values
function replaceRgbaColor(input, newColor = '') {
    if (input && newColor) {
        return input.replace(/rgba\((.*?)\)/g, newColor);
    }
    return input;
}
exports.replaceRgbaColor = replaceRgbaColor;
